<mat-card>
    <div style="margin-top: 20px;">
        <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" class="p-2">
                <img alt="akshaya-logo" src="../../../assets/images/akshaya-logo.png" class="akshaya-logo">
                <img alt="wheat-logo" src="../../../assets/images/wheat.jpg" class="wheat-logo">
            </div>
            <div fxFlex="100" fxFlex.gt-sm="1"></div>
            <div fxFlex="100" fxFlex.gt-sm="2"></div>
            <div fxFlex="100" fxFlex.gt-sm="1"></div>
            <div fxFlex="100" fxFlex.gt-sm="46" class="text-center mt-2">

                <mat-tab-group [@.disabled]="true" [selectedIndex]="0">
                    <mat-tab label="Mobile Login">

                        <div class="p-3">
                            <h2 style="color: aliceblue;text-align: center;">Sign In</h2>
                            <form [formGroup]="phoneLoginFrom" (ngSubmit)="phoneUser(phoneLoginFrom.value)">
                                <mat-form-field appearance="outline" class="w-100 mt-2">
                                    <input matInput placeholder="mobileNumber" type="number"
                                        formControlName="mobileNumber">
                                    <mat-error *ngIf="phoneLoginFrom.controls.mobileNumber.errors?.required">Mobile
                                        number is required
                                    </mat-error>
                                    <mat-error *ngIf="phoneLoginFrom.controls.mobileNumber.hasError('pattern')">Please
                                        enter 10 digit mobile number</mat-error>
                                    <mat-error *ngIf="phoneLoginFrom.controls.mobileNumber.hasError('maxlength')">Please
                                        enter 10 digit mobile number</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mt-1">
                                    <input matInput placeholder="otp" type="number" formControlName="otp">
                                    <mat-error *ngIf="phoneLoginFrom.controls.otp.hasError('minlength')">Please
                                        enter 6 digit otp number</mat-error>
                                </mat-form-field>
                                <div class="text-center mt-2">
                                    <button mat-raised-button color="success" class="submit">
                                        <mat-label>SEND OTP</mat-label>
                                    </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button mat-raised-button color="success" class="submit">
                                        <mat-label>VERIFY OTP</mat-label>
                                    </button>
                                </div>
                                <br />
                            </form>
                        </div>
                    </mat-tab>
                    <mat-tab label="Email Login">
                        <div class="p-3">
                            <h2 style="color: aliceblue;text-align: center;">Sign In</h2>
                            <form [formGroup]="loginForm" (ngSubmit)="loginUser(loginForm.value)">
                                <mat-form-field appearance="outline" class="w-100 mt-2">
                                    <input matInput placeholder="Email" formControlName="email">
                                    <mat-error *ngIf="loginForm.controls.email.errors?.required">Email is required
                                    </mat-error>
                                    <mat-error *ngIf="loginForm.controls.email.hasError('invalidEmail')">Invalid email
                                        address
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="w-100 mt-1">
                                    <input matInput placeholder="Password" type="password" formControlName="password">
                                    <mat-error *ngIf="loginForm.controls.password.errors?.required">Password is required
                                    </mat-error>
                                    <mat-error *ngIf="loginForm.controls.password.hasError('minlength')">Password isn't
                                        long
                                        enough,
                                        minimum of 6 characters</mat-error>
                                </mat-form-field>
                                <div class="fpassword">
                                    <a [routerLink]="['/forgotpassword']"> Forgot Password </a>
                                </div>
                                <div class="text-center mt-2">
                                    <button mat-raised-button color="success" type="submit" class="submit">
                                        <mat-label>SUBMIT</mat-label>
                                    </button>
                                </div>
                                <br />
                            </form>
                        </div>
                        <!-- </div> -->
                    </mat-tab>
                </mat-tab-group>

            </div>
        </div>
    </div>

</mat-card>